export default function LegalDisclaimer() {
  return (
    <div data-testid="legal-disclaimer" className="mt-16 rounded-2xl border border-[#272B36] bg-[#121419] p-6 md:p-8">
      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#D9B36C]">Legal Disclaimer</p>
      <p className="mt-3 text-sm text-slate-400 leading-relaxed">
        This article is provided by Upload Counsel for general informational purposes only. It is not legal advice and does not create an attorney-client relationship. Laws vary by jurisdiction and change over time. Do not act or refrain from acting on the basis of this content without consulting a licensed attorney in your jurisdiction. Upload Counsel is a legal concierge and referral service; legal services are provided by independently engaged attorneys under separate engagement letters.
      </p>
    </div>
  );
}
